import React, {useEffect, useRef, useState} from 'react';
import {useSearchParams} from "react-router";
import {Template} from "../../../components/template/template.jsx";
import SubScroll from "../../../components/sub-scroll/sub-scroll.jsx";
import HeaderButtons from "../../../components/reports/report-menu/header-buttons.jsx";
import {Card} from "../../../components/card/card.jsx";
import Content from "./components/content.jsx";
import ReportUtils from "../../../utils/report-utils.js";
import userService from "../../../services/web/user-service.js";
import materialMovementService from "../../../services/web/material-movement-service.js";
import "../../../css/style-report.css";
import "../../../css/input-date-time.css";

const MaterialMovementsInfo = () => {
    const [loading, setLoading] = useState(false);
    const [reportData, setReportData] = useState(null);

    const [headerSelected, setHeaderSelected] = useState(-1);

    const [searchParams] = useSearchParams();
    const userId = searchParams.get("userId");
    const storageName = searchParams.get("storageName");
    const title = storageName ? `Guichê - ${storageName}` : "Guichê";
    const printComponentRef = useRef(null);

    useEffect(() => {
        if (!userId) return;

        const apply = async () => {
            ReportUtils.applyLoad({
                setLoading,
                clearContent: () => setReportData(null),
            });

            try {
                const [requester, cautions] = await Promise.all([
                    userService.conductorDocumentStatus(userId),
                    materialMovementService.getByUser(userId),
                ]);

                setReportData({requester, cautions: cautions ?? []});
            } catch (error) {
                ReportUtils.alertErrorMessage("Erro ao gerar o relatório.");
                console.error("Erro ao gerar o relatório", error);
            } finally {
                setLoading(false);
            }
        };

        apply();
    }, [userId]);

    const hasReportData = !!reportData?.requester;

    return (
        <SubScroll dependency={[reportData]}>
            <Template isLoading={loading}>
                <Template.Header>
                    <Template.Title>{title}</Template.Title>
                    <HeaderButtons
                        printable={true}
                        headerChange={true}
                        printComponentRef={printComponentRef}
                        reportData={reportData}
                        data={hasReportData ? 1 : 0}
                        headerSelected={headerSelected}
                        setHeaderSelected={setHeaderSelected}
                    />
                </Template.Header>

                <Template.Body className="pl-0!">
                    <Card className="w-full max-w-[1030px] mx-auto p-[0]!">
                        <Card.Body>
                            { hasReportData ? (
                                <Content
                                    reportData={reportData}
                                    data={1}
                                    entity={headerSelected}
                                    title={title}
                                    setLoading={setLoading}
                                    printComponentRef={printComponentRef}
                                />
                            ) : (
                                <div className="alert alert-info p-2 h6 text-center">Nenhum registro encontrado.</div>
                            )}
                        </Card.Body>
                    </Card>
                </Template.Body>
            </Template>
        </SubScroll>
    );
};

export default MaterialMovementsInfo;
